/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    Auth: {

        // REQUIRED - Amazon Cognito Region
        region: 'us-east-1',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'us-east-1_snYjnL0i5',

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: '4n4nlfr2bv39qjnrq4hmlbajj8',


         // OPTIONAL - Hosted UI configuration
        oauth: {
            domain: 'acc-qapps.auth.us-east-1.amazoncognito.com',
            // scope: ['email'],
            scope: ['email', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: 'https://quantumhub.accenture.com/',
            redirectSignOut: 'https://quantumhub.accenture.com/',
            responseType: 'token' // or 'token', note that REFRESH token will only be generated when the responseType is code
        }
    }
};


export default awsmobile;